var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactDetailsEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#5B73E8",
    fillOpacity: 0.1,
    stroke: "#5B73E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5813_3975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6 15C20.5999 13.7518 20.1827 12.5395 19.4148 11.5554C18.6469 10.5714 17.5723 9.87214 16.3616 9.56865C15.1509 9.26517 13.8735 9.37487 12.7322 9.88034C11.5909 10.3858 10.6513 11.2581 10.0624 12.3586C9.47353 13.4592 9.26921 14.7249 9.48189 15.9548C9.69458 17.1847 10.3121 18.3084 11.2363 19.1472C12.1606 19.9861 13.3386 20.4922 14.5833 20.5851C15.828 20.6779 17.0681 20.3523 18.1066 19.6599L18.8836 20.8247C17.7343 21.5931 16.3825 22.0022 15 22C11.1339 22 8 18.8661 8 15C8 11.1339 11.1339 8 15 8C18.8661 8 22 11.1339 22 15V16.05C22.0001 16.5741 21.8321 17.0845 21.5207 17.506C21.2092 17.9276 20.7708 18.2382 20.2698 18.3922C19.7688 18.5462 19.2317 18.5355 18.7372 18.3616C18.2428 18.1877 17.8171 17.8599 17.5228 17.4262C17.0556 17.912 16.4581 18.2526 15.802 18.407C15.1459 18.5614 14.4592 18.5231 13.8244 18.2967C13.1896 18.0703 12.6336 17.6654 12.2233 17.1307C11.813 16.5959 11.5659 15.9541 11.5115 15.2823C11.4572 14.6105 11.5979 13.9373 11.9169 13.3436C12.2359 12.7498 12.7196 12.2608 13.3098 11.9353C13.8999 11.6098 14.5716 11.4616 15.2439 11.5086C15.9163 11.5555 16.5608 11.7956 17.1 12.2H18.5V16.05C18.5 16.3285 18.6106 16.5955 18.8075 16.7925C19.0045 16.9894 19.2715 17.1 19.55 17.1C19.8285 17.1 20.0955 16.9894 20.2925 16.7925C20.4894 16.5955 20.6 16.3285 20.6 16.05V15ZM15 12.9C14.443 12.9 13.9089 13.1212 13.5151 13.5151C13.1212 13.9089 12.9 14.443 12.9 15C12.9 15.5569 13.1212 16.0911 13.5151 16.4849C13.9089 16.8787 14.443 17.1 15 17.1C15.557 17.1 16.0911 16.8787 16.4849 16.4849C16.8788 16.0911 17.1 15.5569 17.1 15C17.1 14.443 16.8788 13.9089 16.4849 13.5151C16.0911 13.1212 15.557 12.9 15 12.9Z",
    fill: "#5B73E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5813_3975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactDetailsEmail);
export default __webpack_public_path__ + "static/media/ContactDetailsEmail.2378b5081521fe8c5f5ebc6c2b5779ce.svg";
export { ForwardRef as ReactComponent };